import React, { useRef } from "react";
import { FaArrowRight } from "react-icons/fa";
import Slider from "react-slick";
import { features } from "../../content/content";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useGsapAnimations from "../../../hooks/useGsapAnimations"; 
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";



const CbgEnergyPage = () => {
  const navigate = useNavigate();


  const activeIndexRef = useRef(0); // Using useRef instead of useState
  const refs = {
    header: useRef(null),
    description: useRef(null),
    buttons: useRef(null),
    contactSection: useRef(null),
  };

  useGsapAnimations(refs);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    cssEase: "ease-in-out",
    beforeChange: (oldIndex, newIndex) => {
      activeIndexRef.current = newIndex; // Update ref without causing re-render
    },
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div
      className="relative text-white py-16 px-5 md:px-20 bg-cover bg-center"
      style={{ backgroundImage: `url(${features.bgImage})` }}
    >
      <div className="absolute inset-0 bg-gray-900 bg-opacity-80"></div>
      <div className="relative z-10">
        <div ref={refs.header} className="max-w-4xl">
          <h6 className="text-green-400 font-semibold text-lg">
            {features.title}
          </h6>
          <h1 className="text-4xl font-bold leading-tight mt-3">
            Providing Value To Our Clients
            <br />
            Through Ongoing Product & Innovation.
          </h1>
        </div>

        <p ref={refs.description} className="mt-6 max-w-2xl text-gray-300 leading-relaxed">
          {features.description}
        </p>

        <div ref={refs.buttons} className="mt-6 flex flex-col md:flex-row gap-4">
          <button
            onClick={() => (navigate("/contact-us"))}
            className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg w-full md:w-auto"
          >
            {features.buttonText1}
          </button>
          <button
            onClick={() => (navigate("/contact-us"))}
            className="border border-gray-300 text-white py-3 px-6 rounded-lg hover:bg-gray-800 shadow-lg w-full md:w-auto"
          >
            {features.buttonText2}
          </button>
        </div>

        <div className="mt-12">
          <Slider {...settings} className="relative">
            {features.cards.map((feature, index) => (
              <div key={index} className="p-3">
                <div className="group bg-white p-6 rounded-lg text-center shadow-lg min-h-[340px] flex flex-col justify-between transition-transform duration-300 hover:shadow-2xl">
                  <div className="text-green-400 text-4xl mt-2">{feature.icon}</div>
                  <h3 className="text-lg text-gray-700 mt-[-4px] font-sans font-semibold">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 font-sans mt-1 text-sm">
                    {feature.description}
                  </p>
                  <div className="flex flex-col items-center group">
                    {/* <button className="mt-4 bg-green-500 text-white flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 group-hover:w-auto group-hover:px-6 group-hover:rounded-full group-hover:opacity-100">
                      <FaArrowRight className="w-5 h-4 transition-all duration-300 group-hover:mr-2" />
                      <span className="hidden group-hover:inline text-base">Learn More</span>
                    </button> */}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div ref={refs.contactSection} className="mt-12 p-8 rounded-lg flex flex-col md:flex-row justify-between items-center shadow-lg">
          <div>
            <p className="text-lg">{features.contactText}</p>
            <button className="mt-4 border border-white py-3 px-6 rounded-lg hover:bg-white hover:text-blue-700 transition"  onClick={() => (navigate("/contact-us"))}>
             
              {features.estimateText}
            </button>
          </div>
          
          

{/* <div className="mt-10 mx-auto max-w-4xl">
  <div className="aspect-w-16 aspect-h-9">
   <iframe width="560" height="315" src="https://www.youtube.com/embed/pUhVfoJdc-s?si=0BT7KHEeOOuJdKJT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
   
  </div>
</div> */}

        </div>
      </div>
    </div>
  );
};

export default CbgEnergyPage;
